/**
 * orga-app-api - kommunikation-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const KommunikationProblemTypes = {
    TroubleTicketNichtGefunden: 'TroubleTicketNichtGefunden',
    MitteilungsVorlageNichtGefunden: 'MitteilungsVorlageNichtGefunden',
    MitteilungsVorlageQuelleNichtBefuellt: 'MitteilungsVorlageQuelleNichtBefuellt',
    MitteilungsVorlageGeloescht: 'MitteilungsVorlageGeloescht',
    MitteilungNichtGefunden: 'MitteilungNichtGefunden',
    MitteilungGeloescht: 'MitteilungGeloescht'
} as const;
export type KommunikationProblemTypes = typeof KommunikationProblemTypes[keyof typeof KommunikationProblemTypes];

